/* eslint-disable */
import * as Types from '../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import { OrganisationWebsitesDetailsBox_ViewerOrganisationFragmentDoc, OrganisationWebsitesDetailsBox_OrganisationProfileFragmentDoc } from '../../features/organisations/boxes/OrganisationWebsitesDetailsBox.generated.js';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type OrganisationWebsitesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type OrganisationWebsitesQuery = { viewer?: { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } | { __typename: 'Viewer', id: string, organisation: { __typename: 'ViewerOrganisation', id: string, title: string, categories: Array<string>, email: any, website: string, profile?: { __typename: 'OrganisationProfile', id: string, slug: string, categories: Array<string>, contactEmail?: any | null, contactWebsite?: string | null, contactAddress?: { __typename: 'Address', id: string, streetLines1: string, city: string, postalCode: string, countryCode: string, location?: { __typename: 'Location', lat: number, lng: number } | null } | null, contactPhones: Array<{ __typename: 'Phone', id: string, number: string, type: Types.PhoneType, main: boolean }> } | null, phones: Array<{ __typename: 'Phone', id: string, number: string, type: Types.PhoneType, main: boolean }>, branchAddress?: { __typename: 'Address', id: string, streetLines1: string, city: string, postalCode: string, countryCode: string, location?: { __typename: 'Location', lat: number, lng: number } | null } | null, billingAddress?: { __typename: 'Address', id: string, streetLines1: string, city: string, postalCode: string, countryCode: string, location?: { __typename: 'Location', lat: number, lng: number } | null } | null } } | null };

export type OrganisationWebsites_AddProfileMutationVariables = Types.Exact<{
  input: Types.AddOrganisationProfileInput;
}>;


export type OrganisationWebsites_AddProfileMutation = { addOrganisationProfile: { __typename: 'AddOrganisationProfileResult', organisation: { __typename: 'Organisation', id: string, profile?: { __typename: 'OrganisationProfile', id: string, slug: string, categories: Array<string>, contactEmail?: any | null, contactWebsite?: string | null, contactAddress?: { __typename: 'Address', id: string, streetLines1: string, city: string, postalCode: string, countryCode: string, location?: { __typename: 'Location', lat: number, lng: number } | null } | null, contactPhones: Array<{ __typename: 'Phone', id: string, number: string, type: Types.PhoneType, main: boolean }> } | null }, profile: { __typename: 'OrganisationProfile', id: string, slug: string } } };


export const OrganisationWebsitesDocument = gql`
    query OrganisationWebsites {
  viewer {
    ... on Viewer {
      id
      organisation {
        id
        title
        ...OrganisationWebsitesDetailsBox_ViewerOrganisation
        profile {
          id
          slug
          ...OrganisationWebsitesDetailsBox_OrganisationProfile
        }
      }
    }
  }
}
    ${OrganisationWebsitesDetailsBox_ViewerOrganisationFragmentDoc}
${OrganisationWebsitesDetailsBox_OrganisationProfileFragmentDoc}`;

/**
 * __useOrganisationWebsitesQuery__
 *
 * To run a query within a React component, call `useOrganisationWebsitesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganisationWebsitesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganisationWebsitesQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrganisationWebsitesQuery(baseOptions?: Apollo.QueryHookOptions<OrganisationWebsitesQuery, OrganisationWebsitesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganisationWebsitesQuery, OrganisationWebsitesQueryVariables>(OrganisationWebsitesDocument, options);
      }
export function useOrganisationWebsitesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganisationWebsitesQuery, OrganisationWebsitesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganisationWebsitesQuery, OrganisationWebsitesQueryVariables>(OrganisationWebsitesDocument, options);
        }
export function useOrganisationWebsitesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganisationWebsitesQuery, OrganisationWebsitesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrganisationWebsitesQuery, OrganisationWebsitesQueryVariables>(OrganisationWebsitesDocument, options);
        }
export type OrganisationWebsitesQueryHookResult = ReturnType<typeof useOrganisationWebsitesQuery>;
export type OrganisationWebsitesLazyQueryHookResult = ReturnType<typeof useOrganisationWebsitesLazyQuery>;
export type OrganisationWebsitesSuspenseQueryHookResult = ReturnType<typeof useOrganisationWebsitesSuspenseQuery>;
export type OrganisationWebsitesQueryResult = Apollo.QueryResult<OrganisationWebsitesQuery, OrganisationWebsitesQueryVariables>;
export const OrganisationWebsites_AddProfileDocument = gql`
    mutation OrganisationWebsites_AddProfile($input: AddOrganisationProfileInput!) {
  addOrganisationProfile(input: $input) {
    organisation {
      id
      profile {
        id
        slug
        ...OrganisationWebsitesDetailsBox_OrganisationProfile
      }
    }
    profile {
      id
      slug
    }
  }
}
    ${OrganisationWebsitesDetailsBox_OrganisationProfileFragmentDoc}`;
export type OrganisationWebsites_AddProfileMutationFn = Apollo.MutationFunction<OrganisationWebsites_AddProfileMutation, OrganisationWebsites_AddProfileMutationVariables>;

/**
 * __useOrganisationWebsites_AddProfileMutation__
 *
 * To run a mutation, you first call `useOrganisationWebsites_AddProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganisationWebsites_AddProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organisationWebsitesAddProfileMutation, { data, loading, error }] = useOrganisationWebsites_AddProfileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOrganisationWebsites_AddProfileMutation(baseOptions?: Apollo.MutationHookOptions<OrganisationWebsites_AddProfileMutation, OrganisationWebsites_AddProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrganisationWebsites_AddProfileMutation, OrganisationWebsites_AddProfileMutationVariables>(OrganisationWebsites_AddProfileDocument, options);
      }
export type OrganisationWebsites_AddProfileMutationHookResult = ReturnType<typeof useOrganisationWebsites_AddProfileMutation>;
export type OrganisationWebsites_AddProfileMutationResult = Apollo.MutationResult<OrganisationWebsites_AddProfileMutation>;
export type OrganisationWebsites_AddProfileMutationOptions = Apollo.BaseMutationOptions<OrganisationWebsites_AddProfileMutation, OrganisationWebsites_AddProfileMutationVariables>;